export default function MasterDetailLayout({ sidebar, sidebarLabel, detailLabel, children }) {
  return <div className="gull-master-detail">
    <aside className="gull-detail-sidebar" aria-label={sidebarLabel}>{sidebar}</aside>
    <section className="gull-detail-preview" aria-label={detailLabel}>{children}</section>
  </div>;
}
